export default function InfiniteListFooter({ loadingMore, hasMore, error }) {
  if (error) {
    return <p className="infinite-list-status infinite-list-status-error">{error}</p>;
  }
  if (loadingMore) {
    return <p className="infinite-list-status">Loading more rows…</p>;
  }
  if (hasMore) {
    return <p className="infinite-list-status">Scroll for more</p>;
  }
  return <p className="infinite-list-status">All rows loaded</p>;
}
